import { ref } from "vue"
import { CollectionLookup, type IPostCodeData } from "./TreeRegistration.model"

export const DEFAULT_POST_CODE_DATA: IPostCodeData = {
  collectionLookupResult: ref(CollectionLookup.NONE),
  hospices: ref([]),
  postCode: ref(""),
}
